import { useSelector } from 'react-redux';
import { Spinner } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { SESSION_STORAGE_VARIABLES, sessionStorageManager } from '@app/services/storageManager';
import { selectAddOns, selectUser } from '@app/redux';

import GroupedAddon from '../GroupedAddonCard';
import StandaloneAddon from '../StandaloneAddon';
import AddonsGridEmptyState from './addons-grid-empty-state';
import AddonsGridErrorState from './addons-grid-error-state';

import styles from '../../styles/grid.module.scss';

const AddonsGrid = () => {
  const { availableAddons } = useSelector(selectAddOns);
  const { loading: userLoading } = useSelector(selectUser);
  const { t } = useTranslation('ShopAddons');
  const { loading, productTypes } = availableAddons;

  if (loading || userLoading) {
    return (
      <div className={styles['wrapper']}>
        <div className={styles['spinnerWrapper']}>
          <Spinner description={t('loading.description')} />
        </div>
      </div>
    );
  }

  if (!productTypes) {
    return <AddonsGridErrorState />;
  }

  const filteredProductTypes = productTypes.filter(
    (productType) =>
      productType.id !== sessionStorageManager.getItem(SESSION_STORAGE_VARIABLES.PURCHASED_PRODUCT_TYPE_ID)
  );

  if (filteredProductTypes.length === 0) {
    return <AddonsGridEmptyState />;
  }

  return (
    <div className={styles['wrapper']}>
      <div className={styles['grid']}>
        {filteredProductTypes.map((addon, i) =>
          addon.is_grouped_product ? (
            <GroupedAddon key={i} rootAddon={addon} />
          ) : (
            <StandaloneAddon key={i} addon={addon} />
          )
        )}
      </div>
    </div>
  );
};

export default AddonsGrid;
